import { graphql } from 'src/gql'
import { SortFindManyTimezoneInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQLDropdownOptions } from 'src/queries/cat/lookups/helpers'

const document = graphql(/* graphql */`
  query timezones($sort: SortFindManyTimezoneInput) {
    lookups {
      Timezone {
        many(sort: $sort) {
          _id
          name
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type Timezones = NonNullable<NonNullable<NonNullable<NonNullable<TData>['lookups']>['Timezone']>['many']>

const useTimezones = useGraphQLDropdownOptions(
  document,
  'lookups.Timezone.many',
  {
    sort: SortFindManyTimezoneInput.OrderAsc
  }
)

export { useTimezones, document as timezonesDocument }
